export default __webpack_public_path__ + "assets/icon-descending-sort.b7fe4610.webp";